export const imagePath = `${window.location.origin}/images/`
